<template>
    <div v-if="!edit">
        <v-icon color="orange" small class="mr-2" @click="toggleEdit" v-if="$root.user.permissions.change_project">
            edit
        </v-icon>
        {{ text }}
    </div>
    <v-select :items="items" :value="project[this.field]" label="Velg fra liste" no-data-text="Ingen valg funnet"
              v-else v-click-outside="toggleEdit" @input="saveSelect" solo class="dropdown-cell-select"/>
</template>

<script>
    export default {
        props: {
            project: Object,
            items: {
                type: Array,
                required: true
            },
            field: String
        },

        data() {
            return {
                edit: false
            }
        },

        methods: {
            toggleEdit() {
                this.edit = !this.edit;
            },
            saveSelect(val) {
                let data = {};
                data[this.field] = val;
                this.$http.patch(`projects/${this.project.id}/`, data).then(response => {
                    this.$root.addMessage('Lagring vellykket.', 'green');
                    this.project.manager = response.data.manager;
                    this.toggleEdit();
                }).catch(() => {
                    this.$root.addMessage('Feil under lagring.', 'red');
                });
            }
        },

        computed: {
            text() {
                let item = this.items.find(it => it.value === this.project[this.field]);
                if (!item) return '';
                return item.text;
            }
        }
    }
</script>

<style>
    .dropdown-cell-select {
        position: absolute;
        margin-top: -19px !important;
    }
</style>